export default {
  setCertificates(state, { certificates }) {
    state.certificates = certificates;
  },
};
